import React from 'react';
import classnames from 'classnames';
const ORGANISM_NAME = 'home-carousel-hero';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';
import formatDate from '../lib/dateHelper';
import getHTMLElement from '../lib/setHtmlHelper';

export default class HomeCarouselHero extends React.Component {
  /* eslint-disable */
  // Reason for disable: to make it a class that can be extended
  constructor(props) {
    super(props);
  }

  render() {
    const getCarouselContent = getContent("staticContent");
    const country = this.props.country.toLowerCase();
    const heroClasses = classnames(
      ORGANISM_NAME,
      this.props.className,
      this.props.height || "tall"
    );
    const palBlue = "circle at 0 0, #0070ba, #1546a0";
    const backgroundImage = this.props.lg_bg;
    const backgroundPosition = "center";
    const backgroundImageStyle = backgroundImage
      ? {
        backgroundImage: `url(${backgroundImage})`,
        backgroundPosition: `${backgroundPosition || "center"}`,
        backgroundSize: "cover",
        backgroundColor: "#0070ba",
      }
      : { backgroundImage: `radial-gradient(${palBlue})` };
    const inlineStyle = Object.assign(
      {},
      this.props.style,
      backgroundImageStyle
    );
    const { language, timezone } = this.props;

    const updatedDate = formatDate({
      dateToFormat: this.props.last_updated,
      country,
      timezone,
      language,
    });

    const fontChange =
      country === "vn" && this.props.locale === "vi_VN" ? "vnFont" : country === 'jp' && this.props.locale === 'ja_JP' ? 'jpFont' : "";
    return (
      <section
        id={null}
        className={heroClasses}
        data-building-block="organism"
        style={inlineStyle}
        aria-hidden={this.props.ariaHidden}
      >
        <div className="container">
          <div className="row">
            <div
              className={`${ORGANISM_NAME}__container col-xs-12 col-lg-9 center-block text-xs-center`}
            >
              <p className="headline2">
                {this.props.category && this.props.category.toUpperCase()}
              </p>
              {this.props.url === "#topics-container" ? (
                <h1 className={`${ORGANISM_NAME}__headline ${fontChange}`}>
                  {getHTMLElement(this.props.heading, { useHTML: true })}
                </h1>
              ) : (
                <h2 className={`${ORGANISM_NAME}__headline ${fontChange}`}>
                  {getHTMLElement(this.props.heading, { useHTML: true })}
                </h2>
              )}
              <p className="date">
                {" "}
                {updatedDate === "Invalid date" ? "" : updatedDate}
              </p>
              <p className={`${ORGANISM_NAME}__paragraph`}>{this.props.desc}</p>
              <a
                data-pa-click={`CarouselCta|${this.props.heading}`}
                role="button"
                className="seehow-btn pypl-btn"
                href={this.props.url}
              >
                {this.props.btn
                  ? this.props.btn
                  : getCarouselContent("brc.carouselButton")}
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
HomeCarouselHero.propTypes = {
  height: PropTypes.string,
  lg_bg: PropTypes.string,
  category: PropTypes.string,
  heading: PropTypes.string,
  last_updated: PropTypes.string,
  desc: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  url: PropTypes.string,
  btn: PropTypes.string,
  ariaHidden: PropTypes.string,
};
